import type { IconName } from '../components/icons';

/**
 * Der Vertriebsprozess als geordnete Schritte. Anders als im LinkedIn-Studio
 * gibt es keine harten Sperren -- Vertrieb laeuft parallel -- aber eine
 * Reihenfolge, die man erklaeren kann: Zielfirmen, Ansprache, Antworten,
 * Vorgang, Angebot, Auswertung.
 */
export type SalesStepId = 'zielfirmen' | 'outreach' | 'antworten' | 'pipeline' | 'angebote' | 'auswertung';

export interface SalesStep {
  id: SalesStepId;
  index: number;
  path: string;
  label: string;
  shortLabel: string;
  description: string;
  icon: IconName;
}

export const SALES_STEPS: SalesStep[] = [
  {
    id: 'zielfirmen', index: 1, path: '/sales-campaigns', label: 'Zielfirmen finden', shortLabel: 'Zielfirmen', icon: 'megaphone',
    description: 'Kampagnen mit KI-Recherche liefern Firmen und Ansprechpartner; die Firmenliste führt sie zusammen.',
  },
  {
    id: 'outreach', index: 2, path: '/lead-sync', label: 'Leads & Outreach', shortLabel: 'Outreach', icon: 'zap',
    description: 'Leads importieren, anreichern und über Lemlist-Kampagnen anschreiben.',
  },
  {
    id: 'antworten', index: 3, path: '/outreach-inbox', label: 'Antworten bearbeiten', shortLabel: 'Antworten', icon: 'inbox',
    description: 'Reaktionen aus den Kampagnen lesen, beantworten und Interesse in einen Vorgang verwandeln.',
  },
  {
    id: 'pipeline', index: 4, path: '/pipeline', label: 'Pipeline', shortLabel: 'Pipeline', icon: 'kanban',
    description: 'Vorgänge je Stufe führen, nächste Schritte terminieren, gewinnen oder verlieren.',
  },
  {
    id: 'angebote', index: 5, path: '/angebote', label: 'Angebote', shortLabel: 'Angebote', icon: 'file-check',
    description: 'Angebot aus dem Leistungskatalog bauen, als PDF verschicken, Annahme festhalten.',
  },
  {
    id: 'auswertung', index: 6, path: '/auswertung', label: 'Auswertung', shortLabel: 'Auswertung', icon: 'pie-chart',
    description: 'Was aus den Kampagnen herauskam – Zustellbarkeit, Antwortquoten, Verlauf.',
  },
];

export const SALES_STEP_COUNT = SALES_STEPS.length;

export interface SalesSideTool {
  path: string;
  label: string;
  description: string;
  icon: IconName;
}

export const SALES_SIDE_TOOLS: SalesSideTool[] = [
  { path: '/aufgaben', label: 'Heute', icon: 'sun', description: 'Aufgaben und Termine: überfällig, heute, diese Woche.' },
  { path: '/companies', label: 'Firmen', icon: 'building', description: 'Eine Akte je Haus: Kontakte, Vorgänge, Chronik.' },
  { path: '/mailboxes', label: 'Postfächer', icon: 'mailbox', description: 'Warm-up und Zustellbarkeit der Versandpostfächer.' },
];

const byId = new Map(SALES_STEPS.map((s) => [s.id, s]));

export function salesStepById(id: SalesStepId): SalesStep {
  return byId.get(id) as SalesStep;
}
